// extracted by mini-css-extract-plugin
export default {"cta":"cG-z","disabled":"dG-z"};